export const linkForConsentToProcessingPersonalDataForKazakhstan = 'https://f.sravni.ru/documents/agreement_mfo_kz.pdf';
